import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_12f4445b from 'nuxt_plugin_bootstrapvue_12f4445b' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuescrollto_772c2a5d from 'nuxt_plugin_vuescrollto_772c2a5d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_recaptcha_7249ea9b from 'nuxt_plugin_recaptcha_7249ea9b' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxttypeform_39aa53da from 'nuxt_plugin_nuxttypeform_39aa53da' // Source: ./nuxt-typeform.js (mode: 'all')
import nuxt_plugin_googleanalytics_14fe327a from 'nuxt_plugin_googleanalytics_14fe327a' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_prismic_d06f502c from 'nuxt_plugin_prismic_d06f502c' // Source: ./prismic/plugins/prismic.js (mode: 'all')
import nuxt_plugin_prismiccomponents_20b7f77e from 'nuxt_plugin_prismiccomponents_20b7f77e' // Source: ./prismic/plugins/prismic-components.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_axiosV2_22f931ca from 'nuxt_plugin_axiosV2_22f931ca' // Source: ../plugins/axiosV2.js (mode: 'all')
import nuxt_plugin_axiosUtils_a47f22f4 from 'nuxt_plugin_axiosUtils_a47f22f4' // Source: ../plugins/axiosUtils.js (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_setexperienceonroute_795197bd from 'nuxt_plugin_setexperienceonroute_795197bd' // Source: ../plugins/set-experience-on-route (mode: 'all')
import nuxt_plugin_setdimension_403f2e05 from 'nuxt_plugin_setdimension_403f2e05' // Source: ../plugins/set-dimension (mode: 'all')
import nuxt_plugin_useractivity_d40d59ca from 'nuxt_plugin_useractivity_d40d59ca' // Source: ../plugins/user-activity (mode: 'client')
import nuxt_plugin_experience_f57bcd40 from 'nuxt_plugin_experience_f57bcd40' // Source: ../plugins/experience (mode: 'all')
import nuxt_plugin_imagesResizer_352071f2 from 'nuxt_plugin_imagesResizer_352071f2' // Source: ../plugins/imagesResizer.js (mode: 'client')
import nuxt_plugin_vueobservevisibility_2d7eef00 from 'nuxt_plugin_vueobservevisibility_2d7eef00' // Source: ../plugins/vue-observe-visibility (mode: 'all')
import nuxt_plugin_bluesnap_136e131d from 'nuxt_plugin_bluesnap_136e131d' // Source: ../plugins/bluesnap.js (mode: 'client')
import nuxt_plugin_vueinfinitescroll_4479822e from 'nuxt_plugin_vueinfinitescroll_4479822e' // Source: ../plugins/vue-infinite-scroll.js (mode: 'client')
import nuxt_plugin_urlbuilder_3612f090 from 'nuxt_plugin_urlbuilder_3612f090' // Source: ../plugins/url-builder.js (mode: 'all')
import nuxt_plugin_globals_57393abd from 'nuxt_plugin_globals_57393abd' // Source: ../plugins/globals.js (mode: 'all')
import nuxt_plugin_dataLayer_64013b46 from 'nuxt_plugin_dataLayer_64013b46' // Source: ../plugins/dataLayer.js (mode: 'client')
import nuxt_plugin_urlChecker_fa7f2d8a from 'nuxt_plugin_urlChecker_fa7f2d8a' // Source: ../plugins/urlChecker.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_seoplugin_2cf25cbe from 'nuxt_plugin_seoplugin_2cf25cbe' // Source: ../plugins/seo-plugin.js (mode: 'all')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_vClickOutside_6739adc2 from 'nuxt_plugin_vClickOutside_6739adc2' // Source: ../plugins/vClickOutside (mode: 'client')
import nuxt_plugin_vxcontentexperience_455d5ab5 from 'nuxt_plugin_vxcontentexperience_455d5ab5' // Source: ../plugins/vx-content-experience (mode: 'client')
import nuxt_plugin_vueclipboard2_77632e5e from 'nuxt_plugin_vueclipboard2_77632e5e' // Source: ../plugins/vue-clipboard2.js (mode: 'client')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_googleoptimize_d63691de from 'nuxt_plugin_googleoptimize_d63691de' // Source: ./google-optimize.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"p:domain_verify","content":"b91e6ce2306fb8a6d200c8c9f57d7347"}],"script":[{"src":"https:\u002F\u002Fapis.google.com\u002Fjs\u002Fplatform.js?onload=init","async":true,"defer":true},{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+'&gtm_auth=AU1ugrxhJK_EQcp9wg5qxA&gtm_preview=env-1';f.parentNode.insertBefore(j,f);};w[y]('GTM-W3R8R6G')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"dns-prefetch","href":"https:\u002F\u002Fapi.vexels.com\u002Fv1\u002F"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fimages.vexels.com\u002F"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.vexels.com\u002F"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.vexels.com\u002Fv1\u002F","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fimages.vexels.com\u002F","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.vexels.com\u002F","crossorigin":true},{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fcdn.vexels.com\u002Ffavicon.ico"},{"rel":"preload","href":"https:\u002F\u002Fcdn.vexels.com\u002Ffonts\u002Fpoppins\u002Fpoppins-regular.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"preload","href":"https:\u002F\u002Fcdn.vexels.com\u002Ffonts\u002Fpoppins\u002Fpoppins-500.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W3R8R6G&gtm_auth=AU1ugrxhJK_EQcp9wg5qxA&gtm_preview=env-1\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_12f4445b === 'function') {
    await nuxt_plugin_bootstrapvue_12f4445b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_772c2a5d === 'function') {
    await nuxt_plugin_vuescrollto_772c2a5d(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_7249ea9b === 'function') {
    await nuxt_plugin_recaptcha_7249ea9b(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxttypeform_39aa53da === 'function') {
    await nuxt_plugin_nuxttypeform_39aa53da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_14fe327a === 'function') {
    await nuxt_plugin_googleanalytics_14fe327a(app.context, inject)
  }

  if (typeof nuxt_plugin_prismic_d06f502c === 'function') {
    await nuxt_plugin_prismic_d06f502c(app.context, inject)
  }

  if (typeof nuxt_plugin_prismiccomponents_20b7f77e === 'function') {
    await nuxt_plugin_prismiccomponents_20b7f77e(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosV2_22f931ca === 'function') {
    await nuxt_plugin_axiosV2_22f931ca(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosUtils_a47f22f4 === 'function') {
    await nuxt_plugin_axiosUtils_a47f22f4(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_setexperienceonroute_795197bd === 'function') {
    await nuxt_plugin_setexperienceonroute_795197bd(app.context, inject)
  }

  if (typeof nuxt_plugin_setdimension_403f2e05 === 'function') {
    await nuxt_plugin_setdimension_403f2e05(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_useractivity_d40d59ca === 'function') {
    await nuxt_plugin_useractivity_d40d59ca(app.context, inject)
  }

  if (typeof nuxt_plugin_experience_f57bcd40 === 'function') {
    await nuxt_plugin_experience_f57bcd40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_imagesResizer_352071f2 === 'function') {
    await nuxt_plugin_imagesResizer_352071f2(app.context, inject)
  }

  if (typeof nuxt_plugin_vueobservevisibility_2d7eef00 === 'function') {
    await nuxt_plugin_vueobservevisibility_2d7eef00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bluesnap_136e131d === 'function') {
    await nuxt_plugin_bluesnap_136e131d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfinitescroll_4479822e === 'function') {
    await nuxt_plugin_vueinfinitescroll_4479822e(app.context, inject)
  }

  if (typeof nuxt_plugin_urlbuilder_3612f090 === 'function') {
    await nuxt_plugin_urlbuilder_3612f090(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_57393abd === 'function') {
    await nuxt_plugin_globals_57393abd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dataLayer_64013b46 === 'function') {
    await nuxt_plugin_dataLayer_64013b46(app.context, inject)
  }

  if (typeof nuxt_plugin_urlChecker_fa7f2d8a === 'function') {
    await nuxt_plugin_urlChecker_fa7f2d8a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_seoplugin_2cf25cbe === 'function') {
    await nuxt_plugin_seoplugin_2cf25cbe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vClickOutside_6739adc2 === 'function') {
    await nuxt_plugin_vClickOutside_6739adc2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vxcontentexperience_455d5ab5 === 'function') {
    await nuxt_plugin_vxcontentexperience_455d5ab5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclipboard2_77632e5e === 'function') {
    await nuxt_plugin_vueclipboard2_77632e5e(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_googleoptimize_d63691de === 'function') {
    await nuxt_plugin_googleoptimize_d63691de(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
